/**
 * Enum for the different types of feedback you can send to a partner. For now you can give feedback regarding the report or the form.
 */
export enum FeedbackTypeEnum {
  REPORT = "report",
  FORM = "form"
}
